import clsx from 'clsx'
import { ASSISTANT_INTERIM_TEXT_CLASS } from 'tripPlanner/components/Chat/useAssistantThoughtFocus'
import { useMemo } from 'react'
import MarkdownRender from 'LuxKit/MarkdownRender'
import { stripContextTags } from 'tripPlanner/utils/contextTag'
import { preprocessChatMarkdown } from 'tripPlanner/utils/chatMarkdown'
import ChatMarkdownWrapper from 'tripPlanner/components/Chat/ChatMarkdownWrapper'

interface Props {
  content: string
  isInterim?: boolean
}

function DrawerAskAIText({ content, isInterim = false }: Props) {
  const markdown = useMemo(() => preprocessChatMarkdown(stripContextTags(content)), [content])
  return (
    <ChatMarkdownWrapper className={clsx(isInterim && ASSISTANT_INTERIM_TEXT_CLASS)}>
      <MarkdownRender content={markdown} fontSize="medium" type="compact" />
    </ChatMarkdownWrapper>
  )
}

export default DrawerAskAIText
